import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/system' 

export default {
	/**
	 * 获取用户列表
	**/
	getAdmin(params){
		params = commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL+'/admin',
			method:'get',
			params
		})
	},

	/**
	 * 添加用户
	**/
    adminAdd(data) {
		return request({
		url: BASE_URL+'/admin',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 修改用户
	**/
	adminEdit(id,data){
		return request({
			url: BASE_URL+'/admin/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除用户
	**/
	adminDel(id){
		return request({
			url: BASE_URL+'/admin/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 用户配置详情
	**/
	userConfig(id){
		return request({
			url: BASE_URL+'/userConfig/'+id,
			method:'GET'
		})
	},

	/**
	 * 修改用户配置项
	**/
	userConfigEdit(id,data){
		return request({
			url: BASE_URL+'/userConfig/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 修改用户配置项
	**/
	updateUserMenus(id,data){
		return request({
			url: BASE_URL+'/updateUserMenus/'+id,
			method:'PUT',
			data
		})
	}
}